import React, { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { apiService, Receipt } from '../services/api'
import { useOverlay } from '../context/OverlayContext'
import { money, fmtDateTime, PayerPill, Spinner } from '../lib/ui'

const SearchPage: React.FC = () => {
  const { openReceipt } = useOverlay()
  const [q, setQ] = useState('')
  const [payer, setPayer] = useState('')

  const { data: receipts = [], isLoading } = useQuery({
    queryKey: ['receipts', 'all'],
    queryFn: () => apiService.getReceipts({ limit: 1000 }),
  })

  let list: Receipt[] = [...receipts].sort((a, b) => b.date.localeCompare(a.date))
  if (q) {
    const needle = q.toLowerCase()
    list = list.filter((r) => r.company.toLowerCase().includes(needle) || (r.notes || '').toLowerCase().includes(needle))
  }
  if (payer) list = list.filter((r) => r.payer === payer)

  const total = list.reduce((s, r) => s + r.total_amount, 0)

  return (
    <>
      <h2 className="page">History</h2>
      <p className="sub">Every receipt, newest first. Tap any to view, edit or delete.</p>

      <div className="glass-card" style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 16 }}>
        <input
          style={{ flex: 1, minWidth: 150, padding: '11px 13px', borderRadius: 11, background: 'var(--surface-2)', border: '1px solid var(--border)', color: 'var(--text)' }}
          placeholder="Search store or note…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
        <select
          style={{ padding: '11px 13px', borderRadius: 11, background: 'var(--surface-2)', border: '1px solid var(--border)', color: 'var(--text)' }}
          value={payer}
          onChange={(e) => setPayer(e.target.value)}
        >
          <option value="">Both</option>
          <option value="David">David</option>
          <option value="Timna">Timna</option>
        </select>
      </div>

      {isLoading ? (
        <div className="center-pad"><Spinner /></div>
      ) : (
        <>
          <div className="tiny muted" style={{ marginBottom: 10 }}>
            {list.length} receipt{list.length !== 1 ? 's' : ''} · {money(total)} total
          </div>
          <div>
            {list.length ? list.map((r) => (
              <div key={r.id} className="row glass" onClick={() => openReceipt(r.id)}>
                <div className="row-left">
                  <div className="ico">{r.company.charAt(0).toUpperCase()}</div>
                  <div>
                    <div className="row-title">{r.company}</div>
                    <div className="row-sub">{fmtDateTime(r.date)}{r.notes ? ` · “${r.notes}”` : ''}</div>
                  </div>
                </div>
                <div className="row-right">
                  <span className="amt">{money(r.total_amount)}</span>
                  <span>
                    <PayerPill payer={r.payer} />{' '}
                    <span className={`pill pill-${r.is_shared ? 'shared' : 'personal'}`}>{r.is_shared ? 'Shared' : 'Personal'}</span>
                  </span>
                </div>
              </div>
            )) : <div className="note note-info">No receipts match.</div>}
          </div>
        </>
      )}
    </>
  )
}

export default SearchPage
